// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@expo/webpack-config/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-corner {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: #393961;\r\n\r\n  border-radius: 20px;\r\n  border: 3px solid transparent;\r\n}\r\n\r\n::-webkit-scrollbar-button {\r\n  display: none;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
